<template>
  <div class="select_dialog_embed">
    <div class="goods_logistics_setup_embed_msg">
      <div class="select_dialog_embed_box">
        <!--弹出框头部-->
        <div class="select_dialog_embed_box_top">
          <p>{{title}}</p>
        </div>

        <!--弹出框信息-->
        <div class="select_dialog_embed_box_content">
          <!--添加-->
          <div v-if="showType === 'add'" class="select_dialog_embed_box_handle add">
            <div>
              <span><i class="fcDel">*</i>店铺：</span>
              <div class="ml5 mr10">
                <el-select v-model="selectStore" multiple collapse-tags placeholder="店铺">
                  <el-option
                    v-for="item in storeList"
                    :key="item.id"
                    :label="item.text"
                    :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div>
              <span><i class="fcDel">*</i>渠道：</span>
              <div class="ml5 mr10">
                <el-select v-model="selectChannel" multiple collapse-tags placeholder="渠道">
                  <el-option
                    v-for="item in channelList"
                    :key="item.id"
                    :label="item.text"
                    :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div>
              <span><i class="fcDel">*</i>物流：</span>
              <div class="mr10">
                <el-select v-model="selectCourierCompany" multiple collapse-tags placeholder="快递公司">
                  <el-option
                    v-for="item in courierCompanyList"
                    :key="item.id"
                    :label="item.text"
                    :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div>
              <span><i class="fcDel">*</i>货号：</span>
              <div><input class="goods_num" type="text" placeholder="货号" maxlength="20" v-model.trim="goodsNum"></div>
            </div>
          </div>

          <!--删除-->
          <div v-if="showType === 'del'" class="select_dialog_embed_box_handle text_center">
            <div class="mb20">
              是否删除当前选择项？
            </div>
          </div>

          <!--批量删除-->
          <div v-if="showType === 'batchDel'" class="select_dialog_embed_box_handle text_center">
            <div class="mb20">
              是否批量删除当前选择的项？
            </div>
          </div>

          <!--导入货品物流-->
          <div v-if="showType === 'import'" class="select_dialog_embed_box_handle">
            <span>选择上传的文件：</span>
            <input type="file" @change="tirggerFile($event)" accept=".xls,.xlsx">
          </div>
        </div>

        <!--弹出框底部-->
        <div class="select_dialog_embed_box_bottom pb30">
          <button class="btn_normal" @click="submitBtn()">确定</button>
          <button class="btn_cancel" @click="cancelBtn(false)">关闭</button>
        </div>
      </div>
    </div>

    <!--加载框-->
    <loading-dialog v-if="isLoading" :type="loadingType"></loading-dialog>

    <!--信息提示框-->
    <msg-dialog v-if="isMsg"
                :txt="txtMsg"
                :is-suc="isSuc"
                @closebtn="closeMsgDialog"></msg-dialog>
  </div>
</template>

<script>
  import LoadingDialog from '../../../public-component/loading-dialog';
  import MsgDialog from '../../../public-component/msg-dialog';

  export default {
    name: 'goods-logistics-setup-embed-msg',
    props: ['title', 'showType', 'msg'],
    components: {LoadingDialog, MsgDialog},
    data() {
      return {
        storeList: [], // 店铺下拉
        // selectStore: '', // 店铺选择
        selectStore: [], // 店铺选择 2022.07.18 改传多选项
        channelList: [], // 渠道下拉
        // selectChannel: '', // 渠道选择
        selectChannel: [], // 渠道选择 2022.07.18 改传多选项
        courierCompanyList: [], // 快递公司下拉
        // selectCourierCompany: '', // 选择的快递公司
        selectCourierCompany: '', // 选择的快递公司 2022.07.18 改传多选项
        goodsNum: null, // 货号
        importFile: null, // 上传文件
        isLoading: false, // 是否显示加载框
        loadingType: 'NOP', // 加载页面类型
        isMsg: false, // 信息框显示
        isSuc: false, // 是否成功
        txtMsg: '' // 信息框内容
      }
    },
    methods: {
      // 获取店铺下拉框信息
      getAllPXShopList() {
        this.$axios.get(this.Global.getAllPXShopList).then((res) => {
          if (!res.data.errorMsg) {
            if (res.data.resData.length) {
              this.storeList = res.data.resData;
              // this.selectStore = res.data.resData[0].id;
              this.selectStore = [];
              this.storeList.splice(this.storeList.findIndex(item => item.id === 0), 1);
            } else {
              this.storeList = res.data.resData;
              // this.selectStore = '';
              this.selectStore = [];
            }
          } else {
            this.storeList = [];
            // this.selectStore = res.data.errorMsg;
            this.selectStore = [];
          }
        });
      },

      // 获取渠道下拉框信息
      getAllStoreroomsList() {
        this.$axios.get(this.Global.getAllStoreroomsList).then((res) => {
          if (!res.data.errorMsg) {
            this.channelList = res.data.resData;
            // this.channelList.splice(0, 0, {id: '', text: '所有渠道'});
            // this.selectChannel = '';
            this.selectChannel = [];
          } else {
            this.channelList = [];
            // this.selectChannel = res.data.errorMsg;
            this.selectChannel = [];
          }
        });
      },

      // 获取快递公司下拉框
      getAllLogisticList() {
        this.$axios.get(this.Global.getAllLogisticList).then((res) => {
          if (!res.data.errorMsg.length) {
            this.courierCompanyList = res.data.resData;
            // this.courierCompanyList.splice(0, 0, {id: '', text: '所有快递'});
            // this.selectCourierCompany = '';
            this.selectCourierCompany = [];
          } else {
            this.courierCompanyList = [];
            // this.selectCourierCompany = res.data.errorMsg;
            this.selectCourierCompany = [];
          }
        });
      },

      // 保存渠道配货号物流信息
      saveStoreroomGoodsLogisticInfo() {
        // console.log(this.selectStore);
        if (this.selectStore.length < 1) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请选择一个店铺';
          return;
        } else if (this.selectChannel.length < 1) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请选择一个渠道';
          return;
        } else if (this.selectCourierCompany.length < 1) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请选择一个物流';
          return;
        } else if (!this.goodsNum) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请填写货号';
          return;
        }
        const params = {
          id: 0,
          storeroomId: this.selectChannel,
          logisticId: this.selectCourierCompany,
          shopId: this.selectStore,
          goodsId: this.goodsNum
        };
        this.$axios.post(this.Global.saveStoreroomGoodsLogisticInfo, params).then((res) => {
          this.sucOrFail(res);
        });
      },

      // 删除渠道配货号物流信息
      delStoreroomGoodsLogisticByIds() {
        const params = this.msg;
        this.$axios.post(this.Global.delStoreroomGoodsLogisticByIds, params).then((res) => {
          this.sucOrFail(res);
        });
      },

      // 获取文件
      tirggerFile(e) {
        this.importFile = e.target.files;
      },

      // 店铺货号指定快递导入【仅支持文件放在FormData方式上传】
      importStoreroomGoodsLogisticExcel() {
        if (!this.importFile) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请选择要导入的文件';
          return;
        }
        this.isLoading = true;
        this.loadingType = 'options';
        const formData = new FormData();
        formData.append('body', this.importFile[0]);
        this.$axios.post(this.Global.importStoreroomGoodsLogisticExcel, formData).then((res) => {
          let timer;
          const self = this;
          timer = setTimeout(function () {
            clearTimeout(timer);
            self.isLoading = false;
            if (res) {
              if (!res.data.errorMsg.length && !res.data.resData) {
                // self.cancelBtn(true);
                self.isMsg = true;
                self.isSuc = true;
                self.txtMsg = '导入成功';
              } else if (res.data.resData) {
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = '导入失败';
                setTimeout(function () {
                  window.open(res.data.resData);
                }, 500);
              } else {
                self.isMsg = true;
                self.isSuc = false;
                self.txtMsg = res.data.errorMsg;
              }
            }
          }, 500);
        });
      },

      // 是否成功
      sucOrFail(res) {
        if (!res.data.errorMsg.length) {
          this.isMsg = true;
          this.isSuc = true;
          this.txtMsg = '操作成功';
        } else {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = res.data.errorMsg;
        }
      },

      // 提交按钮
      submitBtn() {
        if (this.showType === 'add') {
          this.saveStoreroomGoodsLogisticInfo();
        } else if (this.showType === 'del' || this.showType === 'batchDel') {
          this.delStoreroomGoodsLogisticByIds();
        } else if (this.showType === 'import') {
          this.importStoreroomGoodsLogisticExcel();
        }
      },

      // 取消按钮
      cancelBtn(type) {
        this.$emit('cancelbtn', {isShow: false, showType: this.showType, handleType: type});
      },

      // 接收提示框传送的数据
      closeMsgDialog(e) {
        this.isMsg = e;
        if (this.isSuc || this.showType === 'import') {
          this.cancelBtn(true);
        }
      }
    },
    created() {
      if (this.showType === 'add') {
        this.getAllPXShopList();
        this.getAllStoreroomsList();
        this.getAllLogisticList();
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../../assets/css/home-view";

  .goods_logistics_setup_embed_msg {

    .select_dialog_embed_box_handle {
      &.add {
        text-align: center;

        & > div > div {
          display: inline-block;
          width: 200px;
          margin: auto;

          .goods_num {
            width: calc(100% - 20px) !important;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/goods-management/default-delivery-logistics/goods-logistics-setup-embed-msg.vue